import * as SliderPrimitive from "@radix-ui/react-slider"
import * as React from "react"
import { cx } from "./cva.ts"

function Root({ className, ...props }: React.ComponentProps<typeof SliderPrimitive.Root>) {
  return (
    <SliderPrimitive.Root
      className={cx(
        "relative flex w-full touch-none items-center select-none data-[disabled]:opacity-50 data-[orientation=vertical]:h-full data-[orientation=vertical]:min-h-44 data-[orientation=vertical]:w-auto data-[orientation=vertical]:flex-col",
        "after:content-[''] after:absolute after:inset-0",
        "after:data-[orientation=horizontal]:-my-3 after:data-[orientation=horizontal]:h-6",
        "after:data-[orientation=vertical]:-mx-3 after:data-[orientation=vertical]:w-6",
        className,
      )}
      {...props}
    />
  )
}

function Track({ className, ...props }: React.ComponentProps<typeof SliderPrimitive.Track>) {
  return (
    <SliderPrimitive.Track
      className={cx(
        "bg-gray-6 grow overflow-hidden rounded-full",
        "data-[orientation=horizontal]:h-0.5 data-[orientation=horizontal]:w-full",
        "data-[orientation=vertical]:h-full data-[orientation=vertical]:w-0.5",
        className,
      )}
      {...props}
    />
  )
}

function Range({ className, ...props }: React.ComponentProps<typeof SliderPrimitive.Range>) {
  return (
    <SliderPrimitive.Range
      className={cx(
        "bg-gray-12 absolute data-[orientation=horizontal]:h-full data-[orientation=vertical]:w-full",
      )}
      {...props}
    />
  )
}

function Thumb({ className, ...props }: React.ComponentProps<typeof SliderPrimitive.Thumb>) {
  return (
    <SliderPrimitive.Thumb
      className={cx(
        cx(
          "bg-gray-12 block size-2.5 shrink-0 rounded-full shadow-sm relative",
          "transition-[color,box-shadow]",
          "hover:ring-4 focus-visible:ring-4 focus-visible:outline-hidden",
          "disabled:pointer-events-none disabled:opacity-50",
        ),
        className,
      )}
      {...props}
    />
  )
}

export const Slider = {
  Root,
  Track,
  Range,
  Thumb,
}
